import { useState } from "react";
import { Button, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { marcarActaComoPagada, marcarActaComoPagadaSchema } from "./handlers";
import TextInput from "../../components/ReactHookForm/TextInput";
import MuniSpinner from "../../components/MuniSpinner";

const FormMarcarActaComoPagada = (props) => {
  const { acta, setActa, setRecibos } = props;
  const [isLoading, setIsLoading] = useState(false);

  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(marcarActaComoPagadaSchema),
    defaultValues: {
      id_acta: acta.id,
      fecha_pago: null,
      numero_recibo: null,
    },
  });

  return (
    <Form onSubmit={handleSubmit((data) => marcarActaComoPagada(data, setActa, setRecibos, setError, setIsLoading))}>
      <fieldset disabled={isLoading}>
        <div className='mb-3'>
          <label className='mb-2'>Fecha de pago que figura en el recibo</label>
          <input className='form-control' type='date' {...register("fecha_pago")} />
          <p className='text-danger my-1'>{errors?.fecha_pago?.message}</p>
        </div>
        <TextInput
          label='N° de recibo que se pagó (ej.: 261234567)'
          name='numero_recibo'
          type='number'
          register={register}
          errors={errors?.numero_recibo}
        />
        <Button type='submit' className='mt-2'>
          {isLoading ? (
            <div className='d-flex gap-1'>
              <MuniSpinner
                width='18px'
                height='18px'
                circularProgressSize={24}
                circularProgressColor='#FFFFFF'
                fileName='bola-blanca.png'
              />
              Guardando cambios
            </div>
          ) : (
            "Marcar como pagada"
          )}
        </Button>
      </fieldset>
    </Form>
  );
};

export default FormMarcarActaComoPagada;
